var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "chevronLeft_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.53 20c-.25 0-.5-.09-.7-.29l-7.11-6.96a1 1 0 0 1-.3-.71 1 1 0 0 1 .3-.71l7.15-7.08a.996.996 0 1 1 1.41 1.41l-6.43 6.37 6.38 6.25c.39.39.4 1.02.02 1.41-.2.2-.46.3-.71.3z"
})));
export default SvgChevronLeft;